import { useMutation } from 'urql';
import { graphql } from '@/gql/graphql';
import useUserId from '@/hooks/useUserId';
import generateDmId from '@/utils/generateDmId';

const UpsertDm = graphql(/* GraphQL */ `
  mutation UpsertDm($chatId: uuid!, $personId: String!) {
    insert_chat_one(
      object: { id: $chatId, person_id: $personId }
      on_conflict: { constraint: chat_pkey }
    ) {
      id
    }
  }
`);

export default function useGenerateDm() {
  const yourId = useUserId();
  const [, upsertDm] = useMutation(UpsertDm);

  return async (theirId: string) => {
    if (!process.env.EXPO_PUBLIC_UUID_V5_NAMESPACE) {
      throw new Error('EXPO_PUBLIC_UUID_V5_NAMESPACE must be defined.');
    }

    const chatId = generateDmId({
      yourId,
      theirId,
      namespace: process.env.EXPO_PUBLIC_UUID_V5_NAMESPACE,
    });

    if (!chatId) {
      return null;
    }

    const result = await upsertDm({ chatId, personId: theirId });

    if (result.error) {
      return null;
    }

    return result.data?.insert_chat_one?.id ?? chatId;
  };
}
